import Loading from "../atoms/loading";

const LoadingScreen = () => {
  return (
    <main className="flex h-screen items-center justify-center bg-mgs-bg p-8">
      <Loading classes="text-xl" />
    </main>
  );
};

export default LoadingScreen;
